import React from 'react';
import Gmap from './Gmap.jsx';

const Footer = () =>
	<footer>
		<Gmap/>
		<div className='address'>
			Киев<br/>
			переулок Радищева, 8<br/>
			возле метро Нивки/Берестейская
		</div>
	</footer>

export default Footer;